module.exports = __webpack_public_path__ + "static/img/1620_phase_function_Paper_Points.ba0d59e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1620_phase_function_Paper_Points.png
// module id = EKKP
// module chunks = 0